import { ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceLocator } from '../ServiceLocator';
import { ComponentBase } from '../components/component.base';




export class PageBase extends ComponentBase {
    protected moduleId: string = "";

    private ComponentElement: ElementRef;

    constructor(el: ElementRef, moduleId: string = "turbo") {
        super();

        this.moduleId = moduleId;
        this.ComponentElement = el as ElementRef;
        
        
  }


}
